import React, {  useEffect, useState } from 'react';
import Checkbox from './Checkbox';
import DropDownInput from './DropDownInput';
import InputDatePicker from './InputDatePicker';
import Input from './Input';
import MultiSelect from './MultiSelect';
import { showAlertMessage } from '../../MasterComponents/CommonFunctionalities';
import SwitchButton from './SwitchButton';
import CommonCalls from '../../CommonAPICalls/CommonCalls';
import { use } from 'react';
import Loader from '../Simple Loading/Loader';

//Component For Mapping Field Input Boxes.

// ** Props 
{/* 
        mainClassName,
        className, 
        mainTitle,
        required,
        inputClassName,
        disable,
        type,
        inputType,
        label,
        isChecked,
        value,
        gridObjectFunction,
        id 
    */}
// ----

// let textBoxInputSettings = [ 
//     {label:Helper.getLabel(props.language,'',""), className: '', inputType: "text/number/checkbox/datepicker/dropdown", name:'', id:'', }
// ]


const apiCall = new CommonCalls();

const FieldsRenderer = ({ fieldsArray, updateState, currentState,isQUrbaniForm=false }) => {

    const [chipViewInp,setChipViewInp] = useState("")
    const [chipViewInpNumber,setChipViewInpNumber] = useState('')
    const [chipViewInpFemale,setChipViewInpFemale] = useState('')
    const [isSwitchOn, setIsSwitchOn] = useState(false);
    const [totalCowInpNumber, setTotalCowInpNumber] = useState(1);
    const [QurbaniDetails, setQurbaniDetails] = useState(null)
    const [loading,setLoading] = useState(isQUrbaniForm)
     const [mainQurbaniApiData, setQurbaniMainApiData] = useState(null)
     const [oldNumberPortions, setOldNumberPortions] = useState(1)
     const [gender, setGender] = useState("Male")

      const filterByCategoryType = (data, type=1) => {
        return data.filter(item => item.category_type === parseInt(type));
    };

   const GetQurbaniPriceData = async ()=>{
           const response = await apiCall.getQurbaniPrice();
             if (response?.status === 200) {
                 setLoading(false);
                 setQurbaniMainApiData(response?.data)
                 setQurbaniDetails(
                   {
                       number_of_portions: response?.data[0]?.total_number_portions,
                       price_of_portions: response?.data[0]?.single_portion_price,
                       category_type: response?.data[0]?.category_type
                   }
               )
               updateState({
                ...currentState,
                donation_amount:response?.data[0]?.single_portion_price
               })
                 return response;
               } else {
                   setLoading(false);
                   showAlertMessage("Could not Load, Please Reload the Page", "fail");
                 return;
             }
         }

         useEffect(()=>{
            if(isQUrbaniForm)
            {
                setLoading(true)
                GetQurbaniPriceData()
            }
         },[isQUrbaniForm])


           useEffect(()=>{
                 
                 if(isQUrbaniForm && currentState?.category_type)
                 {
         
                 setLoading(true)
                 const defaultData =  filterByCategoryType(mainQurbaniApiData,currentState?.category_type)[0]
                     updateState((prevState) => {
                        return {
                            ...prevState,
                            donation_amount:defaultData?.single_portion_price,
                            portions:1,
                        }
                    })
                     setQurbaniDetails(
                   {
                       number_of_portions: defaultData?.total_number_portions,
                       price_of_portions: defaultData?.single_portion_price,
                       category_type: defaultData?.category_type
                   })
                 setTimeout(()=>{
                     setLoading(false)
         
                 },1000)
                 }
               },[currentState?.category_type])

         

    const onInputCheckboxChangeHandler = (e) => {
        const { id, checked } = e.target;
        updateState((prevState) => {
            return {
                ...prevState,
                [id]: checked
            }
        })
    }

    const onInputDatePickerChangeHandler = (name, value) => {
        updateState((prevState) => {
            return {
                ...prevState,
                [name]: value
            }
        })
    }

    const onClickNameAdd = (e,inpFieldName) => {
       
        const name = inpFieldName; 
        const numberOfPortions =  currentState[inpFieldName]
        let numberOfPortionsAloted = 0
   
        // if(numberOfPortions == 0 )
        // {
        //     showAlertMessage("Enter a valid Number of portions.","fail")
        //     return
        // }
        if(!chipViewInp)
        {
            showAlertMessage("Sacrificer's Name is required","fail")
            return
        }

        
            if(gender == "Male")
            {
                setChipViewInpFemale("")
            }
            else
            {
                setChipViewInpNumber("")
            }
           
      
        updateState((prev) => {
          const oldArray = prev[name] || [];
          oldArray.map((ele)=>{numberOfPortionsAloted += 1})
           if(currentState?.portions < (numberOfPortionsAloted+1) || numberOfPortions > currentState?.portions)
          { 
            showAlertMessage(`To add more names, please increase the number of portions first`,"fail");
            return {
                ...prev
              };

          }
          else if(oldArray.length < currentState?.portions)
          {
              return {
                ...prev,
                [name]: [...oldArray, {name:chipViewInp,fatherName:chipViewInpNumber,wife_of:chipViewInpFemale}],
              };
          }
          else{
            showAlertMessage("Already Added names for sacrifice shares","fail")
            return {
                ...prev
              };
          }
        });
      
        setChipViewInp('')
        setChipViewInpNumber('')
        setChipViewInpFemale('')
      };
    const onInputChangeHandler = (e) => {
        const { name, value } = e.target;
        updateState((prevState) => {
            return {
                ...prevState,
                [name]: value
            }
        })
    }
    const handleSelectionChange = (selectedValues, name) => {
        updateState((prevState) => {
            return {
                ...prevState,
                [name]: selectedValues
            }
        })
    };

    const incrementPortionCount = () => {
        
        if(currentState?.portions >= QurbaniDetails?.number_of_portions)
        {
            showAlertMessage("Maximum number of Portions reached","fail")
            return
        }
        updateState(prevState => ({
            ...prevState,
            portions: prevState.portions + 1,
            donation_amount: (prevState.portions + 1) * QurbaniDetails?.price_of_portions
        }));
    };

    const decrementPortionCount = () => {
        if((currentState?.portions <= ((currentState['sacrifice']?.length ?? 0))))
        {
            showAlertMessage("Please remove a Name for reducing number of portions","fail")
            return
        }
        updateState(prevState => ({
            ...prevState,
            portions: prevState.portions > 1 ? prevState.portions - 1 : 1,
            donation_amount: (prevState.portions > 1 ? prevState.portions - 1 : 1) * QurbaniDetails?.price_of_portions
        }));
    };


    const handleSwitchChange = (newState) => {
      setIsSwitchOn(newState);
      if(newState)
      {
        if(currentState?.portions >= QurbaniDetails?.number_of_portions)
        {
            showAlertMessage("Maximum number of Portions reached","fail")
            return
        }
        setOldNumberPortions(currentState.portions)
          updateState(prevState => ({
            ...prevState,
            portions: 7,
            donation_amount: 7 * QurbaniDetails?.price_of_portions
        }));
      }
      else{
        setTotalCowInpNumber(0)
         if(oldNumberPortions < (currentState['sacrifice']?.length ?? 0))
        {
            updateState(prevState => ({
                ...prevState,
                portions: (currentState['sacrifice']?.length),
                donation_amount: (currentState['sacrifice']?.length) * QurbaniDetails?.price_of_portions
            }));
            return
        }
        updateState(prevState => ({
            ...prevState,
            portions: oldNumberPortions,
            donation_amount: oldNumberPortions * QurbaniDetails?.price_of_portions
        }));
      }
    };

    const cowNumberChange = (e)=>{
        const value = e.target.value
        if(value <= 0)
        {
            setTotalCowInpNumber(0)
            return
        }
        else
        {
            
            if((currentState?.portions + (value*7)) > QurbaniDetails?.number_of_portions)
            {
                showAlertMessage("Maximum number of Portions reached","fail")
                return
            }
            else if((value*7) < (currentState['sacrifice']?.length ?? 0))
            {
        
                showAlertMessage("Please remove Name for reducing number of portions","fail")
                return
            }
            else{

                setTotalCowInpNumber(value)
                updateState(prevState => ({
                    ...prevState,
                    portions: (7 * value),
                    donation_amount: (7 * value) * QurbaniDetails?.price_of_portions
                }));
            }
        }
    }

    return (
        <div className='container-fluid m-0 p-0'>
            <div className='row Input-fileds'>
                {fieldsArray.map((element, index) => {
                    return (
                        <div className={element.className ? element.className : 'col-lg-6'} key={index}>
                            {element.inputType == "readOnly" &&
                                <Input label={element.label} type='text' id={element.id ? element.id : null} disabled={true} name={element.name} value={currentState[element.name]}  />
                            }
                            {element.inputType == "text" &&
                                <Input label={element.label} type='text' id={element.id ? element.id : null} required={element.required ? element.required : false} disabled={element.disable ? element.disable : false} name={element.name} onChange={onInputChangeHandler} value={currentState[element.name]} placeholder={element.placeholder} />
                            }
                            {element.inputType == "number" &&
                                <Input maxValue={element?.maxValue} label={element.label} type='number' id={element.id ? element.id : null} required={element.required ? element.required : false} disabled={element.disable ? element.disable : false} name={element.name} onChange={onInputChangeHandler} value={currentState[element.name] + ''} placeholder={element.placeholder} />
                            }
                            {element.inputType == "dropdown" &&
                                <DropDownInput id={element.id ? element.id : null} required={element.required ? element.required : false} disabled={element.disable ? element.disable : false} label={element.label} options={element.options ? element.options : []} value={currentState[element.name]} defaultSelected={currentState[element.name]} name={element.name} onSelect={onInputChangeHandler} hideDefaultSelect={element?.hideDefaultSelect} />
                            }
                            {element.inputType == "multi_dropdown" &&
                                <MultiSelect options={element?.options} defaultValues={element.defaultValues} onChange={handleSelectionChange} name={element.name} Label={element.label} />
                            }
                            {element.inputType == "checkbox" &&
                                <Checkbox id={element.id ? element.id : null} type={element.inputType} name={element.name} onChange={onInputCheckboxChangeHandler} disableWithoutIcon={element.disable ? element.disable : false} label={element.label} isChecked={currentState[element.name]} />
                            }
                            {element.inputType == "datepicker" &&
                                <InputDatePicker empty={element.emptyDate} timePicker={element.timePicker} id={element.id ? element.id : null} disable={element.disable ? element.disable : false} value={currentState[element.name]} label={element.label} name={element.name} required={element.required ? element.required : false} onChange={onInputDatePickerChangeHandler} />
                            }
                            {element.inputType == "textarea" &&
                                <div className='textarea_default input-container'>
                                    <label className='mb-2'>{element.label ? element.label : null}{element?.required && <span style={{ color: 'red' }}>*</span>}</label>
                                    <textarea rows={6} id={element.id ? element.id : null} disable={element.disable ? element.disable : false} value={currentState[element.name]} name={element.name} inputClassName={element.inputClassName} required={element.required ? element.required : false} onChange={onInputChangeHandler} />
                                </div>
                            }
                            {element.inputType == "password" &&
                                <Input inputType='password_eye' id={element.id ? element.id : null} required={element.required ? element.required : false} disable={element.disable ? element.disable : false} name={element.name} label={element.label} onChange={onInputChangeHandler} value={currentState[element.name]} />
                            }
                            {element.inputType == "switch" &&
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <SwitchButton id={element.id ? element.id : null} initialChecked={element.isSwitchOn} onChange={handleSwitchChange} name={element.name} label={element.label} />
                                    </div>
                                    {
                                        isSwitchOn &&
                                        <div className='col-lg-6'>
                                            <label className='mb-2' style={{color:'#1972B7'}}>Number of Cows</label>
                                            <input className='form-control ' label={"Number of cows"} type='number' placeholder={'Number of Cows'} value={totalCowInpNumber} onChange={cowNumberChange}
                                            />

                                        </div>
                                    }
                                    <div>

                                    </div>
                                </div>
                            }
                            {element.inputType === 'logo' && (
                                <div className="col-12 py-4 d-flex align-items-center">
                                   <div 
                                    style={{border:"3px solid #A5CD37", width:"45%", height:"0px", borderRadius:"10px"}}
                                   ></div>
                                   <img src='/images/icons/donation-cow-icon.png' className='img-fluid px-4' alt='cow icon' />
                                   <div 
                                    style={{border:"3px solid #A5CD37", width:"45%", height:"0px", borderRadius:"10px"}}
                                   ></div>
                                </div>
                            )}
                            {element.inputType === 'portions' && (
                                <>
                                {
                                    loading?
                                        <Loader/>
                                    :
                                        <div className="form-row">
                                            <div className="form-group mb-0">
                                                <label className='form-text'>Select Portions</label>
                                                <div className="btn-group">
                                                    <button type="button" className="connect-button d-flex align-items-center mb-0" onClick={decrementPortionCount}><p className="mb-1">-</p></button>
                                                    <p className='head-h2 align-items-center mb-0'>{currentState.portions}</p>
                                                    <button type="button" className="connect-button d-flex align-items-center mb-0" onClick={incrementPortionCount}><p className="mb-1">+</p></button>

                                                    <h5 className='form-rs-price mb-0'>Rs. {currentState.donation_amount}</h5>
                                                </div>
                                            </div>
                                        </div>
                                }
                                </>
                            )}

                            {element.inputType == "sacrifice" &&
                            <>
                                <form key={element.name} className='under-form-container d-flex align-items-center'>
                                     <div>
                                        <label>
                                            <input
                                            type="radio"
                                            name="gender"
                                            value="Male"
                                            className='ps-3'
                                            checked={gender === "Male"}
                                            onChange={(e) => setGender(e.target.value)}
                                            />
                                            Male
                                        </label>
                                        <label>
                                            <input
                                            type="radio"
                                            name="gender"
                                            className='ps-3'
                                            value="Female"
                                            checked={gender === "Female"}
                                            onChange={(e) => setGender(e.target.value)}
                                            />
                                            Female
                                        </label>
                                    </div>

                                    <div className="add-name ps-lg-0">
                                        {
                                            ((currentState?.portions < ((currentState[element.name]?.length ?? 0) + 1)) || ((currentState[element.name]?.length ?? 0) > currentState?.portions)) ?
                                            <>
                                            <input className='form-control me-3' disabled label={element.label} autocomplete="off" type='text' id={element.id ? element.id : null} name={element.name} placeholder={element.placeholder} value={chipViewInp} onChange={(e)=>{setChipViewInp(e.target.value)}}/>
                                            {
                                                gender == "Male"?
                                                <input className='form-control me-3' disabled label={"Father Name "} autocomplete="off" type='text' id={element.id ? element.id : null} name={element.name} placeholder={"Father Name"} value={chipViewInpNumber} onChange={(e)=>{
                                                setChipViewInpNumber((e.target.value))}}/>
                                                :
                                                <input className='form-control me-3' disabled label={""} autocomplete="off" type='text' id={element.id ? element.id : null} name={element.name} placeholder={"Husband Name"}  value={chipViewInpFemale} onChange={(e)=>{setChipViewInpFemale(e.target.value)}}/>
                                            }
                                            </>
                                            :
                                            <>
                                            <input className='form-control me-3' label={element.label} autocomplete="off" type='text' id={element.id ? element.id : null} name={element.name} placeholder={element.placeholder} value={chipViewInp} onChange={(e)=>{setChipViewInp(e.target.value)}}/>
                                            {
                                                gender == "Male"?
                                                <input className='form-control me-3' label={"Father Name "} autocomplete="off" type='text' id={element.id ? element.id : null} name={element.name} placeholder={"Father Name "} value={chipViewInpNumber} onChange={(e)=>{
                                                    setChipViewInpNumber((e.target.value))}}/>
                                                :
                                                <input className='form-control me-3' label={"Husband Name"} autocomplete="off" type='text' id={element.id ? element.id : null} name={element.name} placeholder={"Husband Name"}  value={chipViewInpFemale} onChange={(e)=>{setChipViewInpFemale(e.target.value)}}/>
                                            }
                                            </>
                                        }
                                        {/* <input className='form-control me-3' label={element.label} autocomplete="off" type='text' id={element.id ? element.id : null} name={element.name} placeholder={element.placeholder} value={chipViewInp} onChange={(e)=>{setChipViewInp(e.target.value)}}/>
                                        <input className='form-control me-3' label={"Father Name"} autocomplete="off" type='text' id={element.id ? element.id : null} name={element.name} placeholder={"Father Name"} value={chipViewInpNumber} onChange={(e)=>{
                                            setChipViewInpNumber((e.target.value))}}/>
                                         <input className='form-control ' label={"Number of protions"} type='number' placeholder={'Number of portions'} value={chipViewInpNumber} onChange={(e)=>{
                                               if (e.target.value >= 0 && e.target.value <= currentState?.portions) {
                                                setChipViewInpNumber(parseInt(e.target.value))}}}/> 
                                        <input className='form-control me-3' label={element.label} autocomplete="off" type='text' id={element.id ? element.id : null} name={element.name} placeholder={"For female: wife's husband name"} /> */}

                                    </div>
                                    <div className='button-container-donation'>
                                        <button className="donation-form-btn"
                                        type='button'
                                        onClick={(e)=>{onClickNameAdd(e, element.name)}}
                                        >Add</button>
                                        
                                    </div>
                                    
                                </form>
                                <div className='d-flex flex-wrap' style={{height:"100px",overflowY:"auto"}}>
                                    {
                                        currentState[element.name] &&
                                        currentState[element.name].map((names,ind)=>{
                                            return(
                                                <div className='under-form-container-chip pt-1'>
                                                        <div className="chip">
                                                            Name: {names?.name} {names?.fatherName ? `| Father Name: ${names?.fatherName}`:""} {names.wife_of ? `| Husband Name : ${names?.wife_of}` :"" }
                                                            {/* Name: {names?.name} {names?.fatherName ? `| Father Name / Husband Name: ${names?.fatherName}`:""}  */}
                                                              
                                                            <span className="chip-close" 
                                                                onClick={() => {
                                                                    const key = element.name;
                                                                    const temp = [...currentState[key]];
                                                                    temp.splice(ind, 1); 
                                                                    updateState((prev) => ({
                                                                      ...prev,
                                                                      [key]: temp, 
                                                                    }));
                                                                  }}                                                                
                                                            >&times;</span>
                                                        </div>
                                                    </div>
                                            )
                                        })
                                    }
                                    </div>
                            </>
                            }
                        </div>
                    )
                })}
            </div>
        </div>
    )
};

export default FieldsRenderer;